import { deviceId, hubspotBaseUrl, locale, portalId, } from '../constants/leadinConfig';
import { initApp } from './appUtils';
export function initBackgroundApp(initFn) {
    function main() {
        if (Array.isArray(initFn)) {
            initFn.forEach(callback => callback());
        }
        else {
            initFn();
        }
    }
    initApp(main);
}
export const getOrCreateBackgroundApp = (refreshToken = '') => {
    if (window.LeadinBackgroundApp) {
        return window.LeadinBackgroundApp;
    }
    const { IntegratedAppEmbedder, IntegratedAppOptions } = window;
    const options = new IntegratedAppOptions()
        .setLocale(locale)
        .setDeviceId(deviceId)
        .setRefreshToken(refreshToken);
    const embedder = new IntegratedAppEmbedder('integrated-plugin-proxy', portalId, hubspotBaseUrl, () => { }).setOptions(options);
    embedder.attachTo(document.body, false);
    embedder.postStartAppMessage(); // lets the app know all all data has been passed to it
    window.LeadinBackgroundApp = embedder;
    return window.LeadinBackgroundApp;
};
